import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/HomeButton.css';

const HomeButton = () => {
    return (
        <div className="header-container">
            <Link className="home-button" to="/">
                Home
            </Link>
            <h1 className="site-title">ULTIMA SPIAGGIA</h1>
        </div>
    );
};

export default HomeButton;
